import { render, staticRenderFns } from "./MetroFullCheckbox.vue?vue&type=template&id=770c60dc&"
import script from "./MetroFullCheckbox.vue?vue&type=script&lang=js&"
export * from "./MetroFullCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports